export default "__VITE_ASSET__B6NSPVR3__"